// extracted by mini-css-extract-plugin
export default {"cusAllSelectOption":"styles-scoped__cusAllSelectOption--YEqJD"};